import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "./../../axios";
import * as url from "./../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import ActionsTable from "./ActionsTable";
import { table_column_names } from "../../utils/constants";

class SubActionsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parentTask: props.parentTask,
      allTasks: [],
      limitValue: 15,
      skipValue: 0,
    };
  }

  getAllActions = filterApplied => {
    // get sub task api call here
    const parentTaskId = this.props.parentTask._id;
    let taskType = "subTask";
    const { skipValue, limitValue } = this.state;
    let skip = skipValue;

    let limit = limitValue;

    if (filterApplied === "APPLY") {
      skip = 0;
      limit = limitValue;
    }

    const { filterParams } = this.props;

    if (filterApplied === "CLEAR") {
      skip = 0;
    }
    axios
      .post(
        url.getTodos(taskType, parentTaskId),
        { filters: filterParams.filtersDoc },
        {
          params: { skip: skipValue, limit: limitValue },
        }
      )
      .then(({ data }) => {
        let allTodos = data.data.taskList;

        this.setState(prevState => ({
          allTasks:
            filterApplied === "APPLY" || filterApplied === "CLEAR"
              ? [...allTodos]
              : [...prevState.allTasks, ...allTodos],
        }));
      });
  };

  handleOnScrollPaginate = () => {
    this.setState(
      prevState => ({
        skipValue: prevState.skipValue + this.state.limitValue,
      }),
      () => {
        this.getAllActions();
      }
    );
  };

  componentDidMount() {}
  render() {
    return (
      <div>
        <ActionsTable
          {...this.props}
          table_params={{
            ...table_column_names["planning"],
            selected: table_column_names["planning"]["1"],
          }}
          isHidden={true}
          getAllData={this.getAllActions}
          allTasks={this.state.allTasks}
          parentActionId={this.state.parentTask._id}
          parentActionPrivacy={this.state.parentTask.privacy}
          parentActionTitle={this.state.parentTask.title}
          tableType="subAction"
          isParentTaskPublic={this.state.parentTask.privacy === "SHARED"}
          parentTaskObj={this.state.parentTask}
          handleOnScrollPaginate={this.handleOnScrollPaginate}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    filterParams: state.sortFilterParams.actions.filter,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: data =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: data =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: data =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    orgChangeSuccess: data => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(SubActionsTab, axios));
